/* Reconcile the native badge after Shopify's cart updates and merchant fee-app changes. */
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  let revision = 0;
  let timers = [];

  async function refresh(expectedRevision) {
    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (expectedRevision !== revision || !Number.isInteger(cart.item_count)) return;
      const count = String(cart.item_count);
      const badge = document.querySelector('#cart-icon-bubble .wbhcartitem');
      if (badge) badge.textContent = count;
      const heading = document.querySelector('cart-drawer.active .drawer__heading');
      if (heading && /\(\s*\d+\s*\)/.test(heading.textContent)) {
        heading.textContent = heading.textContent.replace(/\(\s*\d+\s*\)/, `(${count})`);
      }
    } catch {
      // Keep Shopify's existing server-rendered cart controls on network errors.
    }
  }

  function schedule() {
    const expectedRevision = ++revision;
    timers.forEach(clearTimeout);
    // The first refresh follows Shopify's native drawer render. The merchant
    // fee app may re-render the badge several seconds after its cart update;
    // keep a bounded late check rather than polling indefinitely.
    timers = [650, 2300, 5500, 9000].map(delay => setTimeout(() => refresh(expectedRevision), delay));
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule();
  });
  window.addEventListener('pageshow', event => { if (event.persisted) schedule(); });
  if (Number(document.querySelector('#cart-icon-bubble .wbhcartitem')?.textContent?.trim()) > 0) {
    schedule();
  }
})();
